import { ApprovalRequestType, ESignApproval, RequestType, Status } from '../../../data/types.generated';
import { computeInfoTagForESignApprovals } from '../../../views/common';
import { ApprovalsAppListItem } from '../../../views/components';
import { convertESignRecipientsToApprovers } from './convertESignRecipientsToApprovers';
import { convertESignSenderToPrincipal } from './convertESignSenderToPrincipal';
import { getCurrentUser } from './getCurrentUser';

/**
 * Converts a Syntex record to an ApprovalAppListItem to be consumed by the UI.
 *
 * @param data type ESignApprovals
 * @param approvalType ApprovalRequestType
 * @returns array of ApprovalsAppListItem[]
 */
export const getListItemFromESignApproval = (
    data: ESignApproval,
    approvalType: ApprovalRequestType,
    currentUserId: string
): ApprovalsAppListItem => {
    // TODO: log an error if the approval record is missing a sender or a status https://domoreexp.visualstudio.com/MSTeams/_workitems/edit/2951536

    // This data is then displayed as a last updated date time in the UI.
    // Maybe later we can refactor thing variable to have a more generic name.
    // TODO: Replace data.creationDateTime with a last updated date time once available in Esign Gateway.
    const creationDate = new Date(data.creationDateTime);
    const isActive = data.status === Status.Sent;
    const infoTagProps = computeInfoTagForESignApprovals(data.status, getCurrentUser(data.recipients, currentUserId));

    return {
        approvalId: data.id,
        title: data.title,
        isActive,
        status: infoTagProps.colorStyle,
        statusText: infoTagProps.text,
        creationDate,
        source: data.source ?? '',
        requestedBy: convertESignSenderToPrincipal(data.sender),
        approvers: convertESignRecipientsToApprovers(data.recipients),
        approvalType,
        requestType: RequestType.Esign,
    };
};
